$(".member").click(function () {
  $(".member").removeClass("expanded");
  $(this).addClass("expanded");
  $("html,body").animate({ scrollTop: $(this).offset().top - 100 }, "normal");
});

$(".close").click(function (e) {
  $(".member").removeClass("expanded");
  e.stopPropagation();
});
